import { Component, Input, OnInit } from '@angular/core';
import { LineInterface } from '../../../../lines/models/line.interface';
import { OfferVitrineService } from '../../../services/offer-vitrine.service';
import { MefOfferInterface } from '../../../models/mef-offer.interface';
import { SelectedOptionInterface } from '../../../models/selected-option.interface';
import { OfferDetailsInterface } from '../../../models/offer-details.interface';
import { Store } from '@ngrx/store';
import { SaveMission } from '../../../store/actions/mission.actions';
import { CustomerService } from '../../../../account/services/customer.service';
import { ChangeOfferDateInterface } from '../../../../account/models/change-offer-date.interface';

@Component({
  selector: 'app-change-offer-mef',
  templateUrl: './change-offer-mef.component.html',
  styleUrls: ['./change-offer-mef.component.css'],
  standalone: false
})
export class ChangeOfferMefComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  availableOffers: Array<MefOfferInterface> = [];
  filteredOffers: Array<MefOfferInterface> = [];
  categories: Array<string>|null = null;
  filteredOptions: Array<string> = [];
  selectedCategory: string|null;
  selectedOffer: MefOfferInterface|null;
  selectedOfferDetails: OfferDetailsInterface|null;
  selectedOptions: Array<SelectedOptionInterface>;
  checkedDiscountBoxSfr: boolean;
  invalidOptions: boolean;
  submitted: boolean;
  sfrCustomerId: string|null;
  sfrOrderId: string|null;
  sfrPhoneNumber: string|null;
  invalidSfrPhoneNumber: boolean;
  realOfferPrice: string;
  changeOfferDateInterface: ChangeOfferDateInterface|null;

  constructor(
      private store: Store<any>,
      private offerVitrineService: OfferVitrineService,
      private customerService: CustomerService,
  ) { }

  ngOnInit() {
    this.selectedOffer = null;
    this.selectedCategory = null;
    this.selectedOfferDetails = null;
    this.selectedOptions = [];
    this.checkedDiscountBoxSfr = false;
    this.invalidOptions = false;
    this.submitted = false;
    this.sfrCustomerId = null;
    this.sfrOrderId = null;
    this.sfrPhoneNumber = null;
    this.realOfferPrice = null;
    this.invalidSfrPhoneNumber = false;
    this.changeOfferDateInterface = null;

    this.offerVitrineService.getOfferDetails(this.line.offer.id).subscribe( offerResponse => {
      this.realOfferPrice = offerResponse.base_price_ttc.toFixed(2);
    });
    for (const option of this.line.options) {
      if (option.displayWeb === true) {
        this.filteredOptions.push(option.labelEc);
      }
    }
    this.offerVitrineService.getAvailableOffers(this.line.phoneNumber).subscribe(response => {
      if (response) {
        this.availableOffers = response;
        this.categories = [];
        for (const offer of this.availableOffers) {
          if (this.categories.indexOf(offer.offer_category) == -1) {
            this.categories.push(offer.offer_category);
          }
        }
      }
    });

    this.customerService.getChangeOfferDate().subscribe(response => {
      if (response) {
        this.changeOfferDateInterface = response;
      }
    });
  }

  private isValidOptions() {
    for (const option of this.selectedOptions) {
      if (option.requirement == 'mandatory' && option.id == null) {
        this.invalidOptions = true;
        return false;
      }
    }
    return true;
  }

  confirmation() {
    this.submitted = true;
    this.invalidOptions = false;
    this.invalidSfrPhoneNumber = false;
    if (
        this.checkedDiscountBoxSfr &&
        /^0[1-9]{1}[0-9]{8}$/.test(this.sfrPhoneNumber) === false
    )
    {
      this.invalidSfrPhoneNumber = true;
    } else if (
        this.isValidOptions() &&
        (
            this.checkedDiscountBoxSfr === false ||
            (
                this.checkedDiscountBoxSfr === true &&
                ['', null].indexOf(this.sfrCustomerId) === -1 &&
                ['', null].indexOf(this.sfrOrderId) === -1
            )
        )
    ) {
      let discountBoxSfrOption: SelectedOptionInterface | null = null;
      for (const option of this.selectedOptions) {
        if (option.code === 'remise_box_sfr') {
          discountBoxSfrOption = option;
        }
      }

      if (discountBoxSfrOption) {
        const index = this.selectedOptions.indexOf(discountBoxSfrOption);
        discountBoxSfrOption.additionalFields = {
          sfr_customer_id: this.sfrCustomerId,
          sfr_order_id: this.sfrOrderId,
          sfr_phone_number: this.sfrPhoneNumber
        };
        this.selectedOptions.splice(index, 1);
        this.selectedOptions.push(discountBoxSfrOption);
      }
      const optionsIds = [];
      for (const option of this.selectedOptions) {
        optionsIds.push(option.id);
      }

      this.store.dispatch(
          new SaveMission(
              {
                offerId: this.selectedOffer.offer_id,
                offerLabel: this.selectedOffer.offer_label,
                options : optionsIds,
                phoneNumber: this.line.phoneNumber,
                billingCycleDate: this.changeOfferDateInterface.englishDate
              },
              this.procedureCode
          )
      );
    }
  }

  setSelectedCategory(event: any) {
    this.selectedCategory = event.target.value;
    this.selectedOffer = null;
    this.checkedDiscountBoxSfr = false;
    this.selectedOptions = [];
    this.filteredOffers = [];
    this.selectedOfferDetails = null;
    this.invalidOptions = false;
    this.submitted = false;
    this.sfrCustomerId = null;
    this.sfrOrderId = null;
    this.sfrPhoneNumber = null;
    this.invalidSfrPhoneNumber = false;
    for (const offer of this.availableOffers) {
      if (this.selectedCategory === offer.offer_category) {
        this.filteredOffers.push(offer);
      }
    }
  }

  setSelectedOffer(event: any) {
    this.selectedOptions = [];
    this.selectedOffer = this.filteredOffers.filter(obj => obj.offer_id.toString() === event.target.value)[0];
    this.offerVitrineService.getOfferDetails(this.selectedOffer.offer_id).subscribe( response => {
      this.selectedOfferDetails = response;
      for (const option of this.selectedOfferDetails.options_fmt.stand_alone_options) {
        if (option.requirement === 'mandatory') {
          this.selectedOptions.push({
            id: option.option_id,
            price: option.in_sale_ttc,
            subLabel: null,
            label: option.label,
            code: option.label.toLowerCase().replace(/ /g, '_'),
            requirement: option.requirement,
            additionalFields: null
          });
        }
      }
      for (const optionGroup of this.selectedOfferDetails.options_fmt.option_groups) {
        if (optionGroup.requirements === 'mandatory') {
          this.selectedOptions.push({
            id: null,
            price: null,
            subLabel: null,
            label: optionGroup.label,
            code: optionGroup.label.toLowerCase().replace(/ /g, '_'),
            requirement: optionGroup.requirements,
            additionalFields: null
          });
        }
      }
    });
  }

  isSelected(id: number) {
    return this.selectedOptions.findIndex((obj) => obj.id === id) !== -1;
  }

  setSelectedOptions($event, id: number, price: number, label: string, requirement: string, subLabel: string|null = null) {
    const code = label.toLowerCase().replace(/ /g, '_');
    const optionIndex = this.selectedOptions.findIndex((obj) => obj.code === code);
    if (code === 'remise_box_sfr') {
      this.checkedDiscountBoxSfr = $event.target.checked;
    }
    if (requirement !== 'mandatory') {
      if ($event.target.checked && optionIndex === -1) {
        this.selectedOptions.push({
          id: id,
          price: price,
          code: code,
          label: label,
          requirement: null,
          subLabel: subLabel,
          additionalFields: null
        });
      } else if ($event.target.checked && optionIndex !== -1) {
        this.selectedOptions.splice(optionIndex, 1);
        this.selectedOptions.push({
          id: id,
          price: price,
          code: code,
          label: label,
          requirement: null,
          subLabel: subLabel,
          additionalFields: null
        });
      } else if (!$event.target.checked && optionIndex !== -1) {
        this.selectedOptions.splice(optionIndex, 1);
      }
    } else {
      if ($event.target.checked && optionIndex !== -1) {
        this.selectedOptions.splice(optionIndex, 1);
        this.selectedOptions.push({
          id: id,
          price: price,
          code: code,
          label: label,
          requirement: null,
          subLabel: subLabel,
          additionalFields: null
        });
      } else if (!$event.target.checked && optionIndex !== -1) {
        this.selectedOptions.splice(optionIndex, 1);
        this.selectedOptions.push({
          id: null,
          price: null,
          code: code,
          label: label,
          requirement: null,
          subLabel: null,
          additionalFields: null
        });
      }
    }
  }

  formatDate(date?: string) {
    if (date) {
      const splitDate = date.split('-');
      return splitDate[2] + '/' + splitDate[1] + '/' + splitDate[0];
    }
    return '';
  }
}
